import { CategorySorting, CategoryTabs } from "~/types/Category";

const useCategorySorting = (tabId: MaybeRefOrGetter<CategoryTabs>) => {
  const { t } = useI18n();
  const translateSortLabel = useTranslateSortLabel();

  const defaultValue = computed(() =>
    toValue(tabId) === CategoryTabs.Historical
      ? CategorySorting.ClosingTimeLastToFirst
      : CategorySorting.Featured,
  );
  const options = computed(() => {
    const tabIdValue = toValue(tabId);

    if (tabIdValue === CategoryTabs.Live) {
      return [
        {
          label: t("sort.featured"),
          value: CategorySorting.Featured,
        },
        {
          label: translateSortLabel("closing", "earliest", "latest"),
          value: CategorySorting.ClosingTimeFirstToLast,
        },
        {
          label: translateSortLabel("closing", "latest", "earliest"),
          value: CategorySorting.ClosingTimeLastToFirst,
        },
      ];
    } else if (tabIdValue === CategoryTabs.Historical) {
      return [
        {
          label: translateSortLabel("closing", "latest", "earliest"),
          value: CategorySorting.ClosingTimeLastToFirst,
        },
        {
          label: translateSortLabel("closing", "earliest", "latest"),
          value: CategorySorting.ClosingTimeFirstToLast,
        },
      ];
    }

    return [
      {
        label: t("sort.featured"),
        value: CategorySorting.Featured,
      },
      {
        label: translateSortLabel("starting", "earliest", "latest"),
        value: CategorySorting.StartingTimeFirstToLast,
      },
      {
        label: translateSortLabel("starting", "latest", "earliest"),
        value: CategorySorting.StartingTimeLastToFirst,
      },
    ];
  });

  return { defaultValue, options };
};

export default useCategorySorting;
